import React from 'react'

const formatDate = (date) => {
  if (!date) return "";
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(date));
};

export default function MediaDetailContent({ data = {} }) {
  return (
    <>
      <section className='mediadetail-info-section'>
        <div className='container'>
          <div className='col-lg-12'>
            <div className='mediadetail-info-card'>
              <div className="mediadetail-info-inner">
                <span>DATE:</span>
                <label>{formatDate(data.date)}</label>
              </div>

              {data?.news_type && (
                <div className="mediadetail-info-inner">
                  <span>TYPE:</span>
                  <label>{data.news_type}</label>
                </div>
              )}

              <div className="mediadetail-info-inner">
                <span>SOURCE:</span>
                <label><a href={data.source_url} target="_blank" rel="noreferrer">{data.source}</a></label>
              </div>
            </div>

            <div className='mediadetail-content'>
              <div dangerouslySetInnerHTML={{ __html: data.description || "" }} />

              <a className="theme-btn" href={data.source_url} target="_blank" rel="noreferrer"> <span>read full article on {data.source}</span> </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
